// extracted by mini-css-extract-plugin
module.exports = {"video_class":"qGzG5","loader":"vOY3p"};